import Message, { type MessageProps } from './Message';

export default Message;
export { Message };
export type { MessageProps };
